import { render, staticRenderFns } from "./DemoContactForm.vue?vue&type=template&id=bdf4cc48&"
import script from "./DemoContactForm.vue?vue&type=script&lang=js&"
export * from "./DemoContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports